(function () {
    "use strict";

    const SIGN_ACTION_PSC = "ivm";
    const SIGN_ACTION_PSC_REINVESTIGATIONS = "psc-reinvestigations";

    angular.module("app").controller("ScreeningIvmController", IvmScreeningController);

    IvmScreeningController.$inject = [
        "$scope", "$window", "controllerDecorator", "screeningService", "enumService",
        "FileUploader", "infiniteScrollDataSourceFactory",
    ];
    function IvmScreeningController(
        $scope, $window, controllerDecorator, screeningService, enumService,
        FileUploader, infiniteScrollDataSourceFactory) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation", "files", "dialog"]);

        vm.SetLoadingState(false);

        $scope.ExportDossiers = exportDossiers;

        $scope.DataSource = null;

        $scope.getScreeningResultTypeFilter = _getScreeningResultTypeFilter;
        function _getScreeningResultTypeFilter() {
            if (!$scope.codeScreeningResults) return;
            if (parseInt($scope.DataSource.GetFilter().ScreeningType) == 40)
                return $scope.codeScreeningResults.filter((c) => parseInt(c.Key) == 12 || parseInt(c.Key) == 30);
            return $scope.codeScreeningResults.filter((c) => parseInt(c.Key) > 0);
        }

        $scope.OpenScreening = function (screening) {
            vm.Navigator.OpenIvm(screening.RequestId, screening.RequestStatus);
        };

        $scope.selectAll = false;
        $scope.ToggleSelectAll = function () {
            $scope.selectAll = !$scope.selectAll;
            if (!$scope.DataSource.Items())
                return;

            $scope.DataSource.Items().forEach(i => i.Selected = $scope.selectAll);
        };

        $scope.AreRequestsSelectedForDownloading = function () {
            const requestsToDownload = getSelectedRequests();
            return requestsToDownload.length > 0;
        };

        $scope.AreRequestsSelectedForSigning = () => getSelectedRequests().length > 0;

        function getSelectedRequests() {
            if ($scope.DataSource.IsEmpty())
                return [];

            return $scope.DataSource.Items().filter((req) => req && req.Selected);
        }

        function confirmResults(items) {
            // Skip empty selection
            if (items.length === 0)
                return;

            const itemsByType = Object.groupBy(items, ({ TypeCode }) => TypeCode);

            //! When signing a list of PSCs, all of PSCs in the list should currently have the same specific type (because of the page/filter configuration). As such, an if-else suffices here.
            if (itemsByType[enumService.ScreeningTypeCode.PersonReinvestigation]?.length) {
                screeningService.Sign({ Type: SIGN_ACTION_PSC_REINVESTIGATIONS, Items: itemsByType[enumService.ScreeningTypeCode.PersonReinvestigation] })
                    .then(r => authenticateBeforeSigning(r.data))
                    .catch(vm.ShowError);
            } else if (itemsByType[enumService.ScreeningTypeCode.IVM]?.length) {
                screeningService.Sign({ Type: SIGN_ACTION_PSC, Items: itemsByType[enumService.ScreeningTypeCode.IVM] })
                    .then(r => authenticateBeforeSigning(r.data))
                    .catch(vm.ShowError);
            } else if (itemsByType[enumService.ScreeningTypeCode.SecurityCheck]?.length) {
                screeningService.Sign({ Type: SIGN_ACTION_PSC, Items: itemsByType[enumService.ScreeningTypeCode.SecurityCheck] })
                    .then(r => authenticateBeforeSigning(r.data))
                    .catch(vm.ShowError);
            }
        };

        function authenticateBeforeSigning(response) {
            if (!CheckResultReceived(response)) {
                vm.ShowError(response);
                return;
            }

            const url = `${$window.location.pathname}${$window.location.search}`;
            vm.Dialog.Custom({
                onEscape: true,
                closeButton: true,
                title: vm.getTranslation("GetFasRedirectionTitle"),
                templateUrl: `${vm.Settings.GetBaseUrl()}Account/ChangeFASLogin?returnurl=${encodeURIComponent(url)}`
            });
        }
        // Button for signing
        $scope.ConfirmResults = function () {
            const selectedRequests = getSelectedRequests().map(s => { return { PublicId: s.PublicId, Status: s.Status, TypeCode: s.TypeCode }; });
            confirmResults(selectedRequests);
        };

        $scope.ShowCheckboxes = () => $window.location.pathname.includes("ToAccept") || $window.location.pathname.includes("ToSign");

        $scope.GetExtractSetAccepted = function (screeningType) {
            vm.SetLoadingState(true);

            let screeningIds = [];
            if ($scope.AreRequestsSelectedForDownloading()) {
                screeningIds = getSelectedRequests().map(screening => screening.PublicId);
            }

            screeningService.getPhaseFilesSetAccepted(
                screeningType,
                screeningIds,
                response => {
                    try {
                        vm.File.Save(response, "habil_extracts.zip");
                    }
                    finally {
                        vm.SetLoadingState(false);
                        $scope.DataSource.ResetSearch();
                    }
                },
                function (error) {
                    vm.ShowError(error);
                    vm.SetLoadingState(false);
                }
            );
        };

        $scope.DownloadExtract = downloadExtract;
        function downloadExtract(screening) {
            vm.SetLoadingState(true);

            vm.Api.GetPhaseFile(`id=${screening.PublicId}`)
                .then(function (result) {
                    try {
                        vm.File.Save(result);
                    }
                    finally {
                        $scope.DataSource.ResetSearch();
                    }
                })
                .catch(vm.ShowError)
                .finally(() => vm.SetLoadingState(false));
        };

        $scope.ReopenScreening = function (screening) {
            vm.Dialog.Confirm({
                title: "Habil+",
                message: vm.getTranslation("Screening_Question_Reopen"),
                size: "large",
            }).then(reopen, angular.noop);

            function reopen() {
                vm.SetLoadingState(true);

                vm.Api.ReopenScreeningById(
                    { PublicId: screening.PublicId },
                    response => {
                        if (!CheckResultReceived(response)) {
                            vm.ShowError(response);
                            return;
                        }

                        $scope.DataSource.RemoveItem(screening);

                        vm.ShowSuccess(vm.getTranslation("Actionbar_YourChangesHaveBeenSavedSuccessfully"));
                    },
                    vm.ShowError,
                    () => vm.SetLoadingState(false));
            }
        };

        function initialize() {
            const path = $window.location.pathname.split("/").filter(el => el.length !== 0);
            $scope.action = path[path.length - 1].toLowerCase();

            $scope.DataSource = infiniteScrollDataSourceFactory.Create(vm.Api.SearchMyPagedScreenings, (v) => $scope.isLoadingRequests = v);

            const toSearch = ["toaccept", "toanswer", "tosign"];
            if (!toSearch.some(a => a === $scope.action)) {
                vm.SetLoadingState(false);
                return;
            }

            const pageAndSort = $scope.DataSource.GetPageAndSort();
            if (pageAndSort.SortBy.length > 0) {
                $scope.sortType = pageAndSort.SortBy[0].Name;
                $scope.sortReverse = pageAndSort.SortBy[0].IsReverse;
            }
            else {
                $scope.sortType = "RequestDate";
                $scope.sortReverse = true;
            }

            $scope.DataSource.GetFilter().BaseQuery = $scope.action;
        }

        // TODO: Implement and use a FileUploaderFactory service
        $scope.uploadScreeningResultsController = function ($scope) {
            const uploader = $scope.uploader = new FileUploader({
                url: `${vm.Settings.GetBaseUrl()}api/UploadScreeningResults/invoke`,
                removeAfterUpload: true,
                queueLimit: 10
            });

            // FILTERS
            uploader.filters.push({
                name: "customFilter",
                fn: function (item) {
                    const type = "|" + item.type.slice(item.type.lastIndexOf("/") + 1) + "|";
                    return "|json|".indexOf(type) !== -1;
                }
            });

            uploader.onAfterAddingAll = function () {
                vm.SetLoadingState(true);

                uploader.uploadAll();
            };
            uploader.onErrorItem = function (_fileItem, error) {
                vm.ShowError(error);
                vm.SetLoadingState(false);
            };
            uploader.onCompleteAll = function () {
                vm.SetLoadingState(false);

                $scope.DataSource.ResetSearch();
            };
        };
        $scope.uploadScreeningResultsController.$inject = ["$scope",];

        $scope.SetRowStyle = setRowStyle;
        function setRowStyle(requestItem) {
            if (!requestItem) return;

            if (!requestItem.ScreeningStillValid) return "screeningOutOfTimeLimit";
            if (requestItem.ResultCode === "20") return "retour";
            if (requestItem.IsForeign) return "panel-Foreign bg-Foreign";
        }


        function exportDossiers() {
            vm.SetLoadingState(true);

            const filter = $scope.DataSource.GetFilter();

            vm.Api.ScreeningsExporting(
                { Filter: filter },
                vm.File.saveExport,
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        initialize();
    }
})();
